export default __webpack_public_path__ + "static/abused-ccc9957e25088ae14b79b30d02387862.png";